<app-menu-template3>
  <main class="container-fluid ">
    <article class="row bg-white shadow mb-3 mt-3 ml-0 mr-0 ">
      <section class="col-2 border-right p-4 mb-5">
        <!-- <img [src]="camaraUrl" class="mb-4 img-fluid" alt="" /> -->
        <header class="text-center mb-3">
          <label class="h5">Filtra tu consulta</label>
        </header>
        <form [formGroup]="formFiltroSolicitud" (ngSubmit)="onFiltrar()">
          <div class="form-group" *ngIf="authService.getRolUser(soloConsultaNacional)">
            <label class="small text-secondary mb-0">Cámara de Comercio</label>
            <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara">
              <option class="" value="null" selected="true">
                Seleccione
              </option>
              <option class="" *ngFor="let option of camarasLista; let i = index" value="{{option?.codigo_camara}}"
                [selected]="false">
                {{option?.desc_camara}}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label class="small text-secondary mb-0">NIT</label>
            <input formControlName="nit" type="text" class="form-control form-control-sm">
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="estado">Tipo solicitud</label>
            <select id="estado" formControlName="tipo_solicitud_id" class="form-control custom-select">
              <option value="">Seleccione</option>
              <ng-container *ngFor="let item of tipos_solicitud">
                <option [ngValue]="item.tipo_solicitud_id">{{item.descripcion}}</option>
              </ng-container>
            </select>
          </div>
          <div class="form-group">
            <label class="small text-secondary mb-0">Matrícula</label>
            <input formControlName="matricula" type="text" class="form-control form-control-sm">
          </div>
          <div class="form-group">
            <label class="small text-secondary mb-0">Número RNT</label>
            <input formControlName="codigo_rnt" type="text" class="form-control form-control-sm">
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="estado_rnt">Estado RNT</label>
            <select id="estado_rnt" formControlName="estado_rnt_id" class="form-control custom-select">
              <option value="">Seleccione</option>
              <ng-container *ngFor="let item of estados_rnt">
                <option [ngValue]="item.estado_rnt_id">{{item.descripcion}}</option>
              </ng-container>
            </select>
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="asignado">Asignación</label>
            <select id="asignado" formControlName="asignado" class="form-control custom-select">
              <option value="">Seleccione</option>
              <option value="A">Asignado</option>
              <option value="N">No asignado</option>
            </select>
          </div>
          <div class="form-group">
            <label class="small text-secondary mb-0">Número radicación</label>
            <input formControlName="numero_radicacion" type="text" class="form-control form-control-sm">
          </div>
          <div class="form-row mt-3">
            <button type="reset" class="btn btn-outline-primary border-0 m-auto" (click)="reset()">Limpiar</button>
            <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit">Filtrar</button>
          </div>
        </form>
      </section>
      <section class="col-10 p-4 mt-3 mb-5">
        <div class="d-flex justify-content-between">
          <header class="row form-group d-flex align-items-center">
            <figure class="m-auto">
              <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block p-2 rounded-circle" alt=""
                height="60">
            </figure>
            <div class="col row">
              <label class="text-dark h5 mb-0 font-weight-bold">Listado de solicitudes</label>
            </div>
          </header>
          <div>
            <span class="badge asignada badge-pill p-2 mt-3 mr-2">Asignada</span>
            <span class="badge devuelta badge-pill p-2 mt-3 mr-2">Reingreso</span>
            <span class="badge no-asignada badge-pill p-2 mt-3">No asignada</span>
          </div>
          <!-- <div class="mt-2">
            <button type="reset" class="btn btn-primary m-auto solicitud-btn-principal margin" (click)="onOpenModalSuspencion()">Suspender
              masivamente</button>
            <button type="reset" class="btn btn-primary m-auto solicitud-btn-principal" (click)="onOpenModalCancelacion()">Cancelar
              masivamente</button>
          </div> -->
        </div>
        <div class="table-responsive">
          <app-tablas-order [page] = "paginaActual" [sizeData]="dataTabla.paging.totalItems" (paginado)="onPaginado($event)" (orderBy)="onOrderModel($event)" [headers]="headers">
            <tr *ngFor="let item of solicitudes" class="small"
              [style.borderLeft]="item.asignado === 'N' ? '8px solid #e53935' : (item.es_devuelta ? '8px solid #f57c00' : '8px solid #2F51E0')">
              <td>{{item.nit}}</td>
              <td>{{item.razon_social}}</td>
              <td>{{item.descripcion_tipo_rnt}}</td>
              <td>{{item.descripcion_tipo_solicitud}}</td>
              <td>{{item.fecha_radicacion | date:'d/MMM/yyyy, h:mm a'}}</td>
              <td>{{item.fecha_reingreso | date:'d/MMM/yyyy, h:mm a'}}</td>
              <td>{{item.codigo_rnt}}</td>
              <td>{{item.matricula}}</td>
              <td [ngClass]="{'dias-atraso': item.dias_atraso <= 0}">{{item.dias_atraso}}</td>
              <td>{{item.descripcion_estado_rnt}}</td>
              <td>{{item.numero_radicacion}}</td>
              <td>
                <a href="javascript:void(0)" (click)="modalDetalleProceso(item.rnt_id)">
                  <img src="assets/icons/EYE.png" width="25">
                </a>
              </td>
              <td>
                <ng-template #popContent>
                  <ng-container *ngIf="item.asignado === 'A'; else sin_asignar">
                    <button class="btn btn-outline-light border-0 text-left w-100"
                      (click)="onAcciones(item, AccionesRntType.DetalleSolicitud)">Gestionar solicitud</button>
                  </ng-container>
                  <!-- <button class="btn btn-outline-light border-0 text-left w-100" (click)="onAcciones(item, AccionesRntType.Arrendatario)">Arrendatarios</button> -->
                  <button class="btn btn-outline-light border-0 text-left w-100"
                    (click)="onAnotacion(item)">Anotaciones</button>
                  <ng-container
                    *ngIf="item.tipo_solicitud_id !== tipo_inscripcion && item.estado_rnt_id === estado_activo">
                    <!-- <button class="btn btn-outline-light border-0 text-left w-100" (click)="onReporte(item)">Reporte
                      de registro</button> -->
                    <button class="btn btn-outline-light border-0 text-left w-100"
                      (click)="onCertificado(item)">Dercargar Certificado</button>
                  </ng-container>
                  <ng-template #sin_asignar>
                    <ng-container *ngIf="(authService.getRolUser(tipo_funcionario))">
                      <button class="btn btn-outline-light border-0 text-left w-100" (click)="onAccionesAsignar(item)"
                        *ngIf="item.asignado === 'N'">Asignar</button>
                    </ng-container>
                  </ng-template>
                </ng-template>
                <button type="button" class="btn btn-outline-secondary text-center" placement="bottom"
                  [ngbPopover]="popContent" popoverClass="bg-dark">
                  ..
                </button>
              </td>
            </tr>
          </app-tablas-order>
        </div>
      </section>
    </article>
  </main>
</app-menu-template3>